module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Ditt livshjul","footerText":"Se profilen din"},"en":{"title":"Your wheel of life","footerText":"View your profile"}}')
  delete Component.options._Ctor
}
